import React, { useEffect, useState } from 'react'
import Page from "../../layouts/Page"
import { FormattedMessage, useIntl } from 'react-intl'
import Container from './Container'
import useApi from '../../hooks/useApi'
import Loading from '../../components/Loading'
import RetryApi from '../../components/RetryApi'
import axios from 'axios'
import { customStringify } from '../../utils'
import { network_tl } from '../../translations'
import { useSelector } from 'react-redux'

const Subscription = () => {
    const user = useSelector(state => state.user);
    const { Axios } = useApi();
    const [error, setError] = useState(false);
    //   const [data, setdata] = useState({});
    const intl = useIntl();
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);

    const refreshListing = () => {
        setRefresh(!refresh);
    }

    const getData = async () => {
        setLoading(true);
        setError(false);
        try {

            //   const result = await Axios.get(`api/user/profile`);
            //   setdata(result.data.payload);
            setLoading(false);
        } catch (e) {
            if (axios.isCancel(e)) {

            } else if (e.response) {
                setError(customStringify(e.response.data.description))
            } else {
                setError(network_tl(intl))
            }
            setLoading(false)
        }
    }

    useEffect(() => {
        getData();
    }, [refresh])

    return (
        <Page
            title={<FormattedMessage id="subscription" defaultMessage={"Subscription"} />}
            description={intl.formatMessage({ id: "subscription_desc", defaultMessage: "Check your active plan, manage payments, and renewals." })}
            breadcrumbs={[
                {
                    title: <FormattedMessage id="influencee" defaultMessage={"Influencee"} />,
                    link: "/"
                },
                {
                    title: <FormattedMessage id="subscription" defaultMessage={"Subscription"} />,
                    link: "/subscription"
                },
            ]}
        >
            {
                loading ? (
                    <Loading />

                ) : error ? (
                    <RetryApi error={error} retry={getData} />
                ) : (
                    <Container data={user} />
                )
            }
        </Page>
    )
}

export default Subscription